<template>
  <div class="device-detail-time-page">
    <div class="chart-block">
      <div class="tab-switch">
        <span v-for="item in tabData" :class="[{'current': tabKey==item}]" v-text="item" @click="tabSwitch(item)"></span>
      </div>
      <div class="chart-box">
        <v-chart :options="options_sjtj" />
      </div>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    let tabData = ['日', '周'];
    let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳秒
    return {
      tabData: tabData,
      tabKey: tabData[0],
      sjtjList: [],
      options_sjtj: {},
      StartDate: this.$formatDateTime(todayTime - 3600*24, 'yyyy-MM-dd'),
      EndDate: this.$formatDateTime(null, 'yyyy-MM-dd'),
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData(optionStr) {
      if(optionStr) {
        let options = JSON.parse(optionStr);
        if(options.StartDate) {
          this.StartDate = options.StartDate;
        }
        if(options.EndDate) {
          this.EndDate = options.EndDate;
        }
        console.log('options', options)
      }
      //时间统计
      this.getSjtjList();
    },
    tabSwitch(item) {
      console.log(item)
      this.tabKey = item;
      this.getSjtjList();
    },
    getSjtjList() {
      let self = this;
      this.sjtjList = [
        {
          TunnelNo: '10/11',
          Tasks: [
            {
              TaskType: '早班',
              Count: 320
            },
            {
              TaskType: '中班',
              Count: 120
            },
            {
              TaskType: '晚班',
              Count: 220
            },
            {
              TaskType: '夜班',
              Count: 150
            },
          ]
        },
        {
          TunnelNo: '10/12',
          Tasks: [
            {
              TaskType: '早班',
              Count: 150
            },
            {
              TaskType: '中班',
              Count: 220
            },
            {
              TaskType: '晚班',
              Count: 240
            },
            {
              TaskType: '夜班',
              Count: 100
            },
          ]
        },
        {
          TunnelNo: '10/13',
          Tasks: [
            {
              TaskType: '早班',
              Count: 120
            },
            {
              TaskType: '中班',
              Count: 200
            },
            {
              TaskType: '晚班',
              Count: 230
            },
            {
              TaskType: '夜班',
              Count: 350
            },
          ]
        },
        {
          TunnelNo: '10/14',
          Tasks: [
            {
              TaskType: '早班',
              Count: 120
            },
            {
              TaskType: '中班',
              Count: 200
            },
            {
              TaskType: '晚班',
              Count: 230
            },
            {
              TaskType: '夜班',
              Count: 350
            },
          ]
        },
        {
          TunnelNo: '10/15',
          Tasks: [
            {
              TaskType: '早班',
              Count: 120
            },
            {
              TaskType: '中班',
              Count: 200
            },
            {
              TaskType: '晚班',
              Count: 230
            },
            {
              TaskType: '夜班',
              Count: 350
            },
          ]
        },
        {
          TunnelNo: '10/16',
          Tasks: [
            {
              TaskType: '早班',
              Count: 120
            },
            {
              TaskType: '中班',
              Count: 200
            },
            {
              TaskType: '晚班',
              Count: 230
            },
            {
              TaskType: '夜班',
              Count: 350
            },
          ]
        },
        {
          TunnelNo: '10/17',
          Tasks: [
            {
              TaskType: '早班',
              Count: 120
            },
            {
              TaskType: '中班',
              Count: 200
            },
            {
              TaskType: '晚班',
              Count: 230
            },
            {
              TaskType: '夜班',
              Count: 350
            },
          ]
        },
      ];
      this.setOptionsSjtj();
    },
    setOptionsSjtj() {
      let self = this;
      let colors = this.$charts.colors.style_12;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let xdata = [];
      let sdata = [];

      this.sjtjList.forEach( function(d, di) {
        d.Tasks.forEach( function(t, ti) {
          if(legendData.indexOf(t.TaskType) == -1){
            legendData.push(t.TaskType);
          }
          if(di == 0) {  //
            let tmpdata = [];
            self.sjtjList.forEach( function(dd) {
              dd.Tasks.forEach( function(tt) {
                if(tt.TaskType == t.TaskType) {
                  tmpdata.push(tt.Count)
                }
              })
            });
            let tmp = {
              name: t.TaskType,
              type:'bar',
              barWidth: 10,//柱图宽度
              barGap: '50%',
              barCategoryGap: '200%',
              color: colors[ti],
              data: tmpdata
            }
            sdata.push(tmp)
          }
        });
        xdata.push(d.TunnelNo);
      });

      this.options_sjtj = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          },
          textStyle: {
            fontSize: 20
          }
        },
        legend: {
          //right: 100,
          textStyle: {
            color: chartsConf.legend.color,
            fontSize: 20
          },
          data: legendData
        },
        xAxis: [
          {
            type: 'category',
            nameRotate: 180,
            axisLabel: {
              //rotate: -25,
              color: chartsConf.xAxis.color,
              fontSize: 20
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.xAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis: [
          {
            name: '(时间/小时)',
            nameTextStyle: {
              color: chartsConf.yAxis.color,
              fontSize: 20
            },
            type: 'value',
            axisLabel: {
              color: chartsConf.yAxis.color,
              fontSize: 20
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: chartsConf.yAxis.color_1,
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: [chartsConf.yAxis.color_2],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series : sdata
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceDetailTimeStatistics.vue